import { Button } from "@zapier/design-system-beta";
import { useFeatureFlag } from "../FeatureFlags/FeatureFlags";
import { GoogleSSOButton } from "../GoogleSSOButton";
import { ShareButton } from "../ShareButton/ShareButton";
import { TemplateBookmarkIconButton } from "../TemplateBookmarkIconButton";
import { UseTemplateButton } from "../UseTemplateButton/UseTemplateButton";
import { ZapCardTemplate } from "../ZapCard/ZapCard";
import styles from "./TemplateDetailPageCTAs.module.css";
import { Icon } from "@zapier/design-system";
import { Suspense } from "react";

type TemplateDetailPageCTAsProps = {
  template: ZapCardTemplate;
  isLoggedIn: boolean;
  align?: "start" | "center";
};

export const TemplateDetailPageCTAs = ({
  template,
  isLoggedIn,
  align = "start",
}: TemplateDetailPageCTAsProps) => {
  const showTemplateBookmark =
    isLoggedIn && useFeatureFlag("templates_bookmarking");
  const showGoogleSSOButton =
    !isLoggedIn && useFeatureFlag("templates_google_sso");
  const products = template.products?.items ?? [];
  const isZapTemplate = products.length === 1 && products[0].slug === "zaps";

  return (
    <Suspense>
      <div className={styles.buttons} style={{ justifyContent: align }}>
        {showTemplateBookmark && (
          <TemplateBookmarkIconButton
            templateId={template.id}
            templateSlug={template.slug}
            isZapTemplate={isZapTemplate}
            buttonVariant="button"
          />
        )}
        {isLoggedIn && <ShareButton />}
        {showGoogleSSOButton && (
          <GoogleSSOButton size="medium" slug={template.slug}>
            Continue with Google
          </GoogleSSOButton>
        )}
        <UseTemplateButton
          component={Button}
          slug={template.slug}
          products={products}
          iconStart={isLoggedIn ? <Icon name="formAdd" size={16} /> : null}
          iconEnd={!isLoggedIn ? <Icon name="arrowBigRight" size={20} /> : null}
          shouldCreateAttemptId={isZapTemplate}
          webIntentUrl={template.webIntentUrl}
        >
          {isLoggedIn ? "Try it" : "Use this template"}
        </UseTemplateButton>
      </div>
    </Suspense>
  );
};
